export default __webpack_public_path__ + "static/media/LAT.546c4b05.svg";